"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixtureCatalogPlaces = fixtureCatalogPlaces;
exports.buildReplayFixtureReports = buildReplayFixtureReports;
const FIXTURE_PLACES = [
    { id: 'ent', name: 'כניסה', room: 'entrance' },
    { id: 'kit', name: 'מטבח', room: 'kitchen_salon' },
    { id: 'sal', name: 'סלון', room: 'kitchen_salon' },
    { id: 'bal', name: 'מרפסת', room: 'balcony' },
    { id: 'cor', name: 'מסדרון', room: 'corridor' },
    { id: 'bed', name: 'חדר שינה', room: 'bedroom' },
    { id: 'bath', name: 'אמבטיה', room: 'bathroom' },
    { id: 'wc', name: 'שירותים', room: 'bathroom' },
    { id: 'mamad', name: 'ממ"ד', room: 'mamad' },
    { id: 'mbed', name: 'חדר הורים', room: 'master_bedroom' },
    { id: 'mbath', name: 'חדר רחצה הורים', room: 'master_bath' },
];
const WALK = ['ent', 'kit', 'bal', 'cor', 'bed', 'bath', 'mamad', 'mbed', 'mbath'];
function decoyPlaces() {
    return Array.from({ length: 70 }, (_, index) => ({
        id: `x${index}`,
        name: `חדר משנה ${index + 1}`,
    }));
}
function defectSpecs() {
    const allIds = FIXTURE_PLACES.map((place) => place.id);
    const specific = [
        { id: 'd-door', categoryId: 'c-doors', rooms: ['ent', 'mamad'] },
        { id: 'd-vitrina', categoryId: 'c-windows', rooms: ['kit', 'sal', 'bal'] },
        { id: 'd-rail', categoryId: 'c-windows', rooms: ['bal'] },
        { id: 'd-toilet', categoryId: 'c-bath', rooms: ['bath', 'wc', 'mbath'] },
        { id: 'd-mamad-seal', categoryId: 'c-doors', rooms: ['mamad'] },
        { id: 'd-master-bath', categoryId: 'c-bath', rooms: ['mbath'] },
        { id: 'd-bedroom-wall', categoryId: 'c-walls', rooms: ['bed', 'mbed'] },
        { id: 'd-kitchen-sink', categoryId: 'c-kit', rooms: ['kit'] },
    ];
    const mixed = [
        { id: 'd-window', categoryId: 'c-windows', rooms: ['kit', 'sal', 'bal', 'bed'] },
        { id: 'd-paint', categoryId: 'c-walls', rooms: ['ent', 'cor', 'bed'] },
        { id: 'd-floor', categoryId: 'c-tile', rooms: ['kit', 'sal', 'cor'] },
    ];
    const generic = [
        { id: 'd-grout', categoryId: 'c-tile', rooms: allIds, generic: true },
        { id: 'd-crack', categoryId: 'c-walls', rooms: allIds, generic: true },
        { id: 'd-socket', categoryId: 'c-elec', rooms: allIds, generic: true },
        { id: 'd-gap', categoryId: 'c-tile', rooms: allIds, generic: true },
    ];
    return [...specific, ...mixed, ...generic];
}
function mulberry32(seed) {
    return () => {
        seed |= 0;
        seed = (seed + 0x6d2b79f5) | 0;
        let t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
        t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
}
function pick(rand, items) {
    return items[Math.floor(rand() * items.length)];
}
function placeById(id) {
    const place = FIXTURE_PLACES.find((item) => item.id === id) ?? FIXTURE_PLACES[0];
    return { id: place.id, name: place.name };
}
function nextPlace(rand, current) {
    if (rand() < 0.38)
        return current;
    const index = WALK.indexOf(current);
    if (index >= 0 && rand() < 0.55 && index < WALK.length - 1)
        return WALK[index + 1];
    if (rand() < 0.2 && index > 0)
        return WALK[index - 1];
    return pick(rand, WALK);
}
function fixtureCatalogPlaces() {
    return [...FIXTURE_PLACES.map(({ id, name }) => ({ id, name })), ...decoyPlaces()];
}
function buildReplayFixtureReports(count = 250, seed = 22) {
    const rand = mulberry32(seed);
    const defects = defectSpecs();
    const specific = defects.filter((defect) => !defect.generic);
    const generic = defects.filter((defect) => defect.generic);
    const reports = [];
    for (let i = 0; i < count; i += 1) {
        const length = 16 + Math.floor(rand() * 8);
        let current = rand() < 0.58 ? 'ent' : rand() < 0.7 ? 'kit' : pick(rand, WALK);
        const blocks = [];
        for (let step = 0; step < length; step += 1) {
            const roomDefects = specific.filter((defect) => defect.rooms.includes(current));
            const roll = rand();
            const defect = roll < 0.28 && roomDefects.length
                ? pick(rand, roomDefects)
                : roll < 0.64
                    ? pick(rand, defects.filter((item) => !item.generic && item.rooms.includes(current)))
                    : pick(rand, generic);
            const noisy = defect.generic || rand() < 0.18;
            const placeId = noisy && rand() < 0.35 ? pick(rand, WALK) : current;
            const extra = !defect.generic && rand() < 0.12 ? pick(rand, defect.rooms.filter((id) => id !== placeId)) : undefined;
            blocks.push({
                defectId: defect.id,
                categoryId: defect.categoryId,
                places: [placeById(placeId), ...(extra ? [placeById(extra)] : [])],
            });
            current = nextPlace(rand, current);
        }
        reports.push({ id: `r${i}`, blocks });
    }
    return reports;
}
